import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import * as settingsAction from "store/entities/settingsInfo/action";
import * as dashboardActions from "store/entities/dashboard/action";

import { nameInitials } from 'utils/nameInitials';
import pencilIcon from "assets/images/icons/pencil-icon.svg";
import FormDrawer from '../form-drawer';
import { ButtonLoader } from '.';
import { capitalizeFirstLetter } from "utils/stringFormatter";


const ProfilePictureModal = (props) => {
    const {isOpen, setIsOpen, isEdited, setIsEdited, dashboard, dashboardLoading} = props;
    // const {dashboard} = useSelector(state => state.entities.dashboard);
    const { editTeamMember } = useSelector((state) => state.entities.settingsInfo);
    

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [image, setImage] = useState(null)
    const [isUpdated, setIsUpdated] = useState(false)
    const [isRemoved, setIsRemoved] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    const dispatch = useDispatch();
    const { profileImageLoading, profileImage, profileImageRemoved, profileImageRemovedLoading } = useSelector(state => state.entities.settingsInfo);

    // const profileImageUrl = dashboard?.member?.userType === "employer" ? dashboard?.employer?.profileImage : null;
    const profileImageUrl = dashboard?.member?.profileImage;
    const firstName = dashboard?.member?.firstName;
    const lastName = dashboard?.member?.lastName;

    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        jobTitle: ""
    })
    
    const fileInputRef = useRef(null);

    const handleWrapperClick = () => {
        fileInputRef.current.click(); // Programmatically trigger the file input click
    };

    
    const handleFileChange = (e) => {
        // const selectedFile = e.target.files[0];
        const newlySelectedFile = e.target.files[0];
        setSelectedFile(newlySelectedFile)
        setFile(newlySelectedFile);
        if (newlySelectedFile) {
            setPreview(URL.createObjectURL(newlySelectedFile));
            setImage(URL.createObjectURL(newlySelectedFile))
        }
    };

    const handleRemoveImage = () => {
        setFile(null);
        setPreview(null);
        setImage(null)
    };

    // upload or remove profile image file
    const submitForm = async (e) => {
        e.preventDefault();
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            dispatch(settingsAction.uploadProfileImage(formData));
            // dispatch(employeesAction.resumeEmployeeEarning(id, params)).then(() => {
            //     getEmployees();
            // })
            setIsUpdated(true);
        } else {
            dispatch(settingsAction.removeProfileImage());
            setIsRemoved(true);
            setIsOpen(false);
        }
    };

    
    
// upload profile image to member profile
    useEffect(() => {
        if (profileImage && isUpdated) {
            // getUserProfile();
            // setIsOpen(false);
            // toast.success("Profile Picture updated successfully");
            dispatch(settingsAction.editTeamMember({...form, profileImage: profileImage?.profileImage}, dashboard?.member?.id));
            setIsEdited(true)
            setIsUpdated(false);
        }
    }, [profileImage]);
    
    useEffect(() => {
        if (profileImageRemoved && isRemoved) {
            // getUserProfile();
            // toast.success("Profile Picture removed successfully");
            // setIsOpen(false);
            dispatch(settingsAction.editTeamMember({...form, profileImage: profileImageRemoved?.profileImage}, dashboard?.member?.id));
            setIsEdited(true)
            setIsRemoved(false);
        }
    }, [profileImageRemoved]);
    
    useEffect(() => {
        // if (profileUpdated?.status === "success"){
        if ((editTeamMember?.error === false ) && isEdited){
            // toast.success("Profile updated successfully");
            setIsEdited(false)
            // setIsOpen(false);
            // dispatch(dashboardActions.getDashboard())
        }
        // eslint-disable-next-line
    }, [editTeamMember]);
    

    
    useEffect(() => {
        setForm({
            firstName: capitalizeFirstLetter(dashboard?.member?.firstName) || '',
            lastName: capitalizeFirstLetter(dashboard?.member?.lastName) || '',
            phoneNumber: dashboard?.member?.phoneNumber || '',
            email: dashboard?.member?.email || '',
            role: dashboard?.member?.roleId || '',
            profileImage: dashboard?.member?.profileImage || null,
            jobTitle: dashboard?.member?.jobTitle || '',
        });
        setImage(dashboard?.member?.profileImage)
      }, [dashboard]);

    const handleClose = () => {
        setIsOpen(false);
        setPreview(profileImageUrl);
    };
    
    const emptyProfileImage = profileImageUrl === undefined || profileImageUrl === null || profileImageUrl === ""
    
    const getUserProfile = () => {
        dispatch(dashboardActions.getDashboard());
    };

    useEffect(() => {
        getUserProfile();
    }, [profileImageUrl]);

    return (
        <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form className="p-6" onSubmit={submitForm}>
                <FormDrawer.Title
                    title="Profile Picture"
                    description="Add a picture to personalize your profile"
                    showCloseButton={true}
                    close={handleClose}
                />
                
                <div>
                    <div className='my-8 relative mx-auto w-full'>
                        <div className=' flex justify-center relative h-[185px] w-full'>
                            {/* {(profileImageUrl === null ? false : (preview === null || emptyProfileImage)) ? ( */}
                            {!image ? (
                                <button type='button' onClick={handleWrapperClick} className='flex justify-center items-center rounded-full text-center text-white bg-ep-primary p-6'
                                    style={{
                                        borderRadius: '50%',
                                        width: '185px',
                                        height: '185px',
                                        fontSize: "80px",
                                        cursor: "pointer"
                                    }}>
                                    {nameInitials(firstName, lastName)}
                                </button>
                            ) : (
                                <button type='button' onClick={handleWrapperClick} className='flex justify-center mx-auto relative h-[185px] rounded-full'>
                                    <img 
                                        className='h-[185px] w-full relative z-0 rounded-full'
                                        style={{
                                            borderRadius: '50%',
                                            width: '185px',
                                            height: '185px',
                                            objectFit: 'cover',
                                            cursor: "pointer"
                                        }}
                                        src={preview || image} alt="profile" 
                                    />
                                </button>
                            )}
                        </div>
                        
                        <button style={{cursor: "pointer"}} type='button' className="text-sm font-normal cursor-pointer text-white rounded-full w-14 h-14 flex justify-center border-2 border-ep-primary-50 items-center bg-ep-primary-600 absolute top-0 right-20 z-50">
                            <input style={{cursor: "pointer"}} type="file" ref={fileInputRef} accept="image/*" onChange={handleFileChange} className='opacity-0 w-12 h-12 absolute bottom-2 right-1 cursor-pointer' />
                            <img style={{cursor: "pointer"}} src={pencilIcon} alt="edit" className="cursor-pointer" />
                        </button>
                    </div>
                    
                    <button onClick={submitForm} disabled={profileImageLoading}>
                        {profileImageLoading && 'Uploading...'}
                    </button>

                    <div className="p-1 -mt-[5px] flex items-center space-x-3">
                        <ButtonLoader onClick={handleRemoveImage} loading={profileImageRemovedLoading} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white">
                            Remove
                        </ButtonLoader>
                        <ButtonLoader type="submit" loading={profileImageLoading} disabled={preview ? (file === null) : (file || preview)} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                            Save Changes
                        </ButtonLoader>
                    </div>    
                </div>
            </form>
        </FormDrawer>
    )
};

export default ProfilePictureModal;
